import React, {useState} from 'react';

import {EnhanceCommentView} from 'src/modules/ai/comment/enhance-comment.view';
import {createTypingEffect} from 'src/modules/ai/utils/createTypingEffect';
import {enhanceComment} from 'src/openapi/apis/AiCommentControllerApi';
import {useAppDispatch} from 'src/store';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    comment: string,
    disabled: boolean,
    onChange: (comment: string) => void,
};

export const EnhanceCommentController = (props: Props) => {
    const {
        comment,
        disabled,
        onChange,
    } = props;

    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();
    const [onEnhancing, setOnEnhancing] = useState(false);
    const [enhancedComment, setEnhancedComment] = useState('');

    const onEnhanceClick = async () => {
        if (comment) {
            setOnEnhancing(true);

            const response =
                await dispatch(enhanceComment({enhanceCommentRequest: {comment}}));

            if (response.payload.success) {
                createTypingEffect(response.payload.data, setEnhancedComment);
            }

            if (response.payload.error) {
                onCreateNote({
                    id: 'enhanceComment',
                    status: Status.ERROR,
                    message: response.payload.data.message,
                    buttonProps: {iconProps: {type: Icons.CLOSE}},
                    autoHideTimeout: 10000,
                });
            }

            setOnEnhancing(false);
        }
    };

    return (
        <EnhanceCommentView
            enhancedComment={enhancedComment}
            setEnhancedComment={setEnhancedComment}
            onEnhancing={onEnhancing}
            disabled={disabled}
            onEnhanceClick={onEnhanceClick}
            onChange={onChange}
        />
    );
};
